import { createEvent, restore } from 'effector'
import { MyProfile } from '../../api/parts/managers/types'
import { logOut } from '../auth/model.logout'

export const setMyProfile = createEvent<MyProfile>()
export const $myProfile = restore(setMyProfile, null).reset(logOut)
